import DocumentTypeService from "@/services/bytepro/documentType.service";

export const documentTypeApi = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    getAll({ commit }) {
      return DocumentTypeService.getAll().then(
        (resp) => {
          commit("dummy", "DocumentTypeService.getAll() - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "DocumentTypeService.getAll() - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
  },
};
